module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetMedium@2x.d9f6793.jpg";